// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QueryString from 'query-string';
import Helmet from 'react-helmet';
import { Redirect } from 'react-router-dom';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import ResetPasswordForm from './ResetPasswordForm';
import { AuthWrapper, LoginCard, Logo, LoginSection } from '../styles';

const ErrorMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => `${theme.metrics.margin}px`};
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.error};
  margin-top: ${({ theme }) => `${theme.metrics.margin}px`};
`;

type Props = {
  isResetting: boolean,
  error: ?Object,
  t: any,
  theme: any,
  onResetPassword: (password: string, passwordValidation: string, token: string) => mixed,
  actions: {
    openSnackbar: (type: string, message: string) => mixed,
  },
};

type State = { token: string };

class ResetPasswordPage extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      token: '',
    };

    (this: any).onResetPassword = this.onResetPassword.bind(this);
  }

  componentWillMount() {
    const queryParams = QueryString.parse(location.search);

    this.setState({ token: queryParams.token });
  }

  async onResetPassword(fields: Object): Promise<*> {
    await this.props.onResetPassword(fields.password, fields.passwordValidation, this.state.token);
    if (!this.props.error) {
      this.setState({ token: '' });
      this.props.actions.openSnackbar('message', this.props.t('passwordChangeSuccess'));
    }
  }

  render() {
    const { error, isResetting, t, theme: { images: { logo, background } } } = this.props;

    if (!this.state.token) {
      return <Redirect to="/" />;
    }

    return (
      <AuthWrapper background={background}>
        <Helmet>
          <title>{t('passwordChange')}</title>
        </Helmet>
        <LoginCard zDepth={5}>
          <LoginSection>
            <Logo src={logo} alt="logo" />
            {error &&
              <ErrorMessageWrapper>
                <ErrorMessage>{t('passwordChangeError')}</ErrorMessage>
                <ErrorMessage>{t('passwordChangeErrorContact')}</ErrorMessage>
              </ErrorMessageWrapper>
            }
            {!isResetting && <ResetPasswordForm onSubmit={this.onResetPassword} isResetting={isResetting} />}
          </LoginSection>
        </LoginCard>
      </AuthWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ openSnackbar }, dispatch),
  };
}

export default translate('commonAuthentication')(connect(mapStateToProps, mapDispatchToProps)(withTheme(ResetPasswordPage)));



// WEBPACK FOOTER //
// ./src/common/modules/authentication/resetPassword/ResetPasswordPage.js